import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { Box } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { BlankView } from 'src/Components/blank-view'
import { makeStyles } from 'tss-react/mui'
import { DocumentLink } from '../types'
import ExternalDocumentLink from './ExternalDocumentLink'

const useStyles = makeStyles()(theme => ({
  paperContent: {
    paddingRight: 12,
    paddingLeft: 12,
  },
}))

// #region DocumentSheetsPaper

interface DocumentSheetsPaperProps {
  documentLinks: DocumentLink[]
}

export const DocumentSheetsPaper: React.FC<DocumentSheetsPaperProps> = ({ documentLinks }) => {
  const { classes } = useStyles()

  return (
    <Paper title={t('document-links.card-title')} contentClassName={classes.paperContent}>
      <DocumentSheets documentLinks={documentLinks} />
    </Paper>
  )
}

// #endregion DocumentSheetsPaper

// #region DocumentSheets

const DocumentSheets: React.FC<DocumentSheetsPaperProps> = ({ documentLinks }) => {
  if (documentLinks.length === 0) {
    return (
      <BlankView
        title={t('document-links.blank-view.title')}
        explanation={t('document-links.blank-view.explanation')}
        imageVariant="NEUTRAL"
        fullHeight
      />
    )
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(2, 1fr)'], gap: 2 }}>
      {documentLinks.map(link => (
        <ExternalDocumentLink key={link.key} marketReference={link.marketReference} title={link.title} link={link.link} />
      ))}
    </Box>
  )
}

// #endregion DocumentSheets
